class CrosshairController {
  game: any;
  crosshairEl: HTMLElement | null;
  hitMarkerEl: HTMLElement | null;
  _hitMarkerTimeout: ReturnType<typeof setTimeout> | null;
  _isAiming: boolean;
  _defaultSize: number;
  _aimSize: number;
  _hitColor: string;
  _defaultColor: string;

  constructor(game: any) {
    this.game = game;
    this.crosshairEl = null;
    this.hitMarkerEl = null;
    this._hitMarkerTimeout = null;
    this._isAiming = false;
    this._defaultSize = 24;
    this._aimSize = 16;
    this._hitColor = '#ff3333';
    this._defaultColor = '#ffffff';
  }

  init() {
    this.createCrosshair();
    this.createHitMarker();
  }

  createCrosshair() {
    let el = document.getElementById('crosshair');
    if (!el) {
      el = document.createElement('div');
      el.id = 'crosshair';
      el.className = 'crosshair';
      document.body.appendChild(el);
    }
    this.crosshairEl = el;
    this._updateCrosshairStyle();
  }

  createHitMarker() {
    let el = document.getElementById('hit-marker');
    if (!el) {
      el = document.createElement('div');
      el.id = 'hit-marker';
      el.className = 'hit-marker';
      el.style.display = 'none';
      document.body.appendChild(el);
    }
    this.hitMarkerEl = el;
  }

  setAiming(isAiming: boolean) {
    this._isAiming = isAiming;
    this._updateCrosshairStyle();

    if (this.game.thirdPersonCameraController) {
      this.game.thirdPersonCameraController.setAimMode(isAiming);
    }
  }

  showHitMarker() {
    if (!this.hitMarkerEl) return;

    this.hitMarkerEl.style.display = 'block';
    this.hitMarkerEl.style.borderColor = this._hitColor;

    if (this._hitMarkerTimeout) {
      clearTimeout(this._hitMarkerTimeout);
    }

    this._hitMarkerTimeout = setTimeout(() => {
      if (this.hitMarkerEl) {
        this.hitMarkerEl.style.display = 'none';
      }
    }, 200);
  }

  _updateCrosshairStyle() {
    if (!this.crosshairEl) return;

    const size = this._isAiming ? this._aimSize : this._defaultSize;
    this.crosshairEl.style.width = size + 'px';
    this.crosshairEl.style.height = size + 'px';
    this.crosshairEl.style.borderColor = this._defaultColor;

    if (this._isAiming) {
      this.crosshairEl.classList.add('aiming');
    } else {
      this.crosshairEl.classList.remove('aiming');
    }
  }

  update(_delta: number) {
  }

  dispose() {
    if (this._hitMarkerTimeout) {
      clearTimeout(this._hitMarkerTimeout);
    }
    if (this.crosshairEl && this.crosshairEl.parentNode) {
      this.crosshairEl.parentNode.removeChild(this.crosshairEl);
    }
    if (this.hitMarkerEl && this.hitMarkerEl.parentNode) {
      this.hitMarkerEl.parentNode.removeChild(this.hitMarkerEl);
    }
    this.crosshairEl = null;
    this.hitMarkerEl = null;
  }
}

export { CrosshairController };
